import React, { useState, useEffect } from "react";
import { Line } from "react-chartjs-2";
import { CandlestickSeries, XAxis, YAxis, ChartCanvas, Chart } from "react-financial-charts";
import axios from "axios";
import * as d3 from 'd3';
import MarketStatus from './MarketStatus';

const NiftyChart = ({config}) => {
  const [data, setData] = useState([]);
  const [chartType, setChartType] = useState("line");

  useEffect(() => {
    const endDate = new Date();
    const startDate = new Date();
    startDate.setMonth(startDate.getMonth() - 1);

    const formatDate = (date) => date.toISOString().split('T')[0];
    const start_date = formatDate(startDate);
    const end_date = formatDate(endDate);

    const API_URL = `${config.PY_API_URL}/category/products/charting?symbol=Nifty 50&start_date=${start_date}&end_date=${end_date}&interval=10m`;
    
    axios.get(API_URL)
      .then(response => {
        const intervalMinutes = 10;
        const intervalMilliseconds = intervalMinutes * 60 * 1000;
        let currentTimestamp = startDate.getTime();
        const formattedData = response.data.data.map((d) => {
          const dataPoint = {
            x: new Date(currentTimestamp).toLocaleString('en-GB', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' }),
            open: d.Open,
            high: d.High,
            low: d.Low,
            close: d.Close,
            volume: d.Volume,
          };
          currentTimestamp += intervalMilliseconds;
          return dataPoint;
        });
        setData(formattedData);
      })
      .catch(error => console.error("Error fetching chart data:", error));
  }, []);

  const lineChartData = {
    labels: data.map(d => d.x),
    datasets: [
      {
        label: "Nifty 50",
        data: data.map(d => d.close),
        borderColor: "rgba(75,192,192,1)",
        backgroundColor: "rgba(75,192,192,0.4)",
        fill: false,
        borderWidth: 2,
        pointRadius: 0.44,
        pointHoverRadius: 2,
        yAxisID: 'left-y-axis',
      },
    ],
  };

  const toggleChartType = () => {
    setChartType(chartType === "line" ? "candlestick" : "line");
  };

  const documentStyle = getComputedStyle(document.documentElement);
  const textColor = documentStyle.getPropertyValue('--text-color');


  const chartOptions = {
    interaction: {
      mode: 'index',
      intersect: false
    },
    plugins: {
        legend: {
            labels: {
                color: textColor
            }
        },
        tooltips: {
          mode: 'index',
          intersect: false,
        },
    },
    
    scales: {
        x: {
            ticks: {
              maxTicksLimit: 12,
            },
            grid: {
            }
        }
    }
};

  return (
    <div>
        <MarketStatus config={config}/>
        {( data && data.length && <>
            {/* <button onClick={toggleChartType}>
                Toggle to {chartType === "line" ? "Candlestick" : "Line"} Chart
            </button> */}
            {chartType === "line" ? (
                <Line data={lineChartData} options={chartOptions} />
            ) : (
                <ChartCanvas
                height={400}
                width={800}
                ratio={3}
                margin={{ left: 50, right: 50, top: 10, bottom: 30 }}
                seriesName="MSFT"
                data={data}
                xAccessor={d => d.x}
                xScale={d3.scaleTime()}
                xExtents={[data[0].x, data[data.length - 1].x]}
                >
                <Chart id={1} yExtents={d => [d.high, d.low]}>
                    <XAxis axisAt="bottom" orient="bottom" ticks={6} />
                    <YAxis axisAt="left" orient="left" ticks={5} />
                    <CandlestickSeries />
                </Chart>
                </ChartCanvas>
            )}
      </> )}
    </div>
  );
};

export default NiftyChart;
